import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataProductSubTypesState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataProductSubTypeReducer.productSubTypesFeatureKey]
);

export const getStaticDataProductSubTypesFailure = createSelector(
  getStaticDataProductSubTypesState,
  staticDataCountriesReducer.fromStaticDataProductSubTypeReducer.getProductSubTypesFailure
);

export const getStaticDataProductSubTypesResponse = createSelector(
  getStaticDataProductSubTypesState,
  staticDataCountriesReducer.fromStaticDataProductSubTypeReducer.getProductSubTypesResponse
);

export const getStaticDataProductSubTypesisLoaded = createSelector(
  getStaticDataProductSubTypesState,
  staticDataCountriesReducer.fromStaticDataProductSubTypeReducer.getProductSubTypesIsLoaded
);
